import { createFileRoute } from '@tanstack/react-router';

import { Route as NewRoute } from 'routes/_private/_route/_internal/people/$identityId/_candidate/tasks/route';

/** Forwards to `/people/:identityId` (see the parent route). */
export const Route = createFileRoute(
  '/_private/_route/_internal/candidates/$candidateId/tasks',
)({
  validateSearch: NewRoute.options.validateSearch,
});
